import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowLeftCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.707 8.707a1 1 0 0 0-1.414-1.414zM8 12l-.707-.707a1 1 0 0 0 0 1.414zm3.293 4.707a1 1 0 0 0 1.414-1.414zM16 13a1 1 0 1 0 0-2zm5-1a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm-.707 4.293-4 4 1.414 1.414 4-4zm-4 5.414 4 4 1.414-1.414-4-4zM16 11H8v2h8z"
    />
  </svg>
);
export default SvgArrowLeftCircle;
